import { PageResponse } from '..';
import { Label } from './label';
import { Session } from './session';
import { Project } from './project';
import { PageRequest } from '../pageRequest';

export interface Evidence {
    id: string;
    source: string;
    title: string;
}

export class Player {
    id?: string;
    platformClientId?: string;
    name?: string;
    profileUrl?: string;
    lastLogin?: string;
    email?: string;
    ip?: string;
    status?: string;
    labels?: Label[];
    sessions?: Session[];
    projects?: Project[];
    accusations?: any[]
}

export class PlayerProfileSearchReq extends PageRequest{
    searchCriterias: SearchCriteria[];

    getSearchCriteriaKey(searchCriteria: string): SearchCriteriaKey {
        if ( searchCriteria === SearchCriteriaKey.LABEL) {
            return SearchCriteriaKey.LABEL;
        }else if ( searchCriteria === SearchCriteriaKey.PLAYER) {
            return SearchCriteriaKey.PLAYER;
        // fall back
        }else {
            return SearchCriteriaKey.PLAYER;
        }
     }
}

export class SearchCriteria{
    key?: string;
    operation?: string;
    value?: any;
}


export class PlayerResponse extends PageResponse {
    content: Player[];
}

export class PlayerScore {
    playerScoreHistory: PlayerScoreHistory[];
    suspicionScore: number;
    trustScore: number;
    updateDate: Date;
}

export class PlayerScoreHistory {
    suspicionScore: number;
    trustScore: number;
    creationDate: Date;
}

export enum SearchCriteriaKey {
    LABEL = "label",
    PLAYER = "player"

}



